import { SectionHeading, Reveal } from "./Motion";
import { BookingForm } from "./BookingForm";
import { ContactInfo } from "./ContactInfo";
import { Floral } from "./Floral";

export const Booking = () => (
  <section id="contact" className="relative overflow-hidden bg-cream-deep section-pad" data-testid="contact-section">
    <Floral pos="tl" />
    <div className="relative z-10 mx-auto max-w-[1300px]">
      <SectionHeading eyebrow="Book your date" title="Let's begin" script="your story" align="center" testid="contact-heading" />
      <div className="mt-16 grid gap-8 lg:grid-cols-12">
        <Reveal className="min-w-0 lg:col-span-4 rounded-[28px] border border-gold/20 bg-cream p-6 sm:p-9">
          <ContactInfo />
        </Reveal>
        <Reveal delay={0.1} className="min-w-0 lg:col-span-8 rounded-[28px] border border-gold/25 bg-white p-6 shadow-[0_40px_80px_-50px_rgba(74,74,66,0.5)] sm:p-10">
          <p className="mb-8 font-serif text-3xl text-ink">Booking inquiry</p>
          <BookingForm />
        </Reveal>
      </div>
    </div>
  </section>
);
